<div [ngClass]="{'input-group': small, 'invisible-div': !small}">
    <div class="input-group-prepend" *ngIf="small">
        <label class="b3__form-control input-group-text" [ngClass]="{'is-focused': focused}"
            [attr.for]="inputId">{{label}}</label>
    </div>
    <div class="b3__form-control" [ngClass]="{
       'has-placeholder': placeholder || _inputValue,
       'is-focused': focused, 'not-label': small, 'is-disabled': disabled,
       'is-valid': !disabled && (hasNgCtrol && ngControl.touched) && this.validate && this.isValid === true,
       'is-invalid': !disabled && (hasNgCtrol && ngControl.touched) && this.validate && this.isValid === false
       }">
        <label [attr.for]="inputId" *ngIf="!small">{{label}}</label>
        <textarea #input [style.height.px]="height" [style.resize]="'none'" [attr.id]="inputId"
            class="form-control b3-ga-input" [attr.type]="type" [attr.name]="name" [attr.placeholder]="placeholder"
            [attr.size]="size" [attr.autocomplete]="autocomplete" [attr.maxlength]="maxlength" [attr.aria-label]="label"
            [disabled]="disabled" [(ngModel)]="_inputValue" (keyup)="handleKeyUp($event)" (focus)="handleFocus($event)"
            (input)="handleInput($event)" (blur)="handleBlur($event)"></textarea>
    </div>
</div>